import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import React from 'react';

export type StyledDivListProps = React.HTMLAttributes<HTMLDivElement>;

const StyledDivList = styled.div<StyledDivListProps>(
  {
    [media('xs')]: {
      height: '100%',
      padding: '5px 10px'
    },
    [media('lg')]: {
      display: 'none'
    },
    a: {
      textDecoration: 'none'
    }
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.colors.white,
    a: {
      color: theme.palette.colors.midnightBlue
    }
  })
);

export default StyledDivList;
